import React from 'react'
import HeaderPc from './HeaderPc'
import HeaderMobile from './HeaderMobile'

function Header(props) {
  const windowWidth = window.innerWidth
  const isMobile = windowWidth < 600
  const { style, enScroll } = props
  return isMobile ? <HeaderMobile style={style} enScroll={enScroll} /> : <HeaderPc style={style} enScroll={enScroll} />
}

export default Header
